export class ProduktionsmalPlanMode {
    static get top(): string { return "top"; }
    static get detail(): string { return "detail"; }
}
